// @generated by protoc-gen-es v2.10.0 with parameter "target=ts,import_extension=none"
// @generated from file proto/sem/middleware/planning.proto (package sem.middleware.planning, syntax proto3)
/* eslint-disable */

import type { JsonObject, Message } from "@bufbuild/protobuf";
import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import { file_google_protobuf_struct } from "@bufbuild/protobuf/wkt";

/**
 * Describes the file proto/sem/middleware/planning.proto.
 */
export const file_proto_sem_middleware_planning: GenFile = /*@__PURE__*/
  fileDesc("CiNwcm90by9zZW0vbWlkZGxld2FyZS9wbGFubmluZy5wcm90bxIXc2VtLm1pZGRsZXdhcmUucGxhbm5pbmciXgoLUGxhbm5pbmdSdW4SDgoGcnVuX2lkGAEgASgJEhAKCHByb3ZpZGVyGAIgASgJEhUKDXBsYW5uZXJfbW9kZWwYAyABKAkSFgoObWF4X2l0ZXJhdGlvbnMYBCABKAUiYAoPUGxhbm5pbmdTdGFydGVkEjEKA3J1bhgBIAEoCzIkLnNlbS5taWRkbGV3YXJlLnBsYW5uaW5nLlBsYW5uaW5nUnVuEhoKEnN0YXJ0ZWRfYXRfdW5peF9tcxgCIAEoAyKWAgoRUGxhbm5pbmdJdGVyYXRpb24SMQoDcnVuGAEgASgLMiQuc2VtLm1pZGRsZXdhcmUucGxhbm5pbmcuUGxhbm5pbmdSdW4SFwoPaXRlcmF0aW9uX2luZGV4GAIgASgFEg4KBmFjdGlvbhgDIAEoCRIRCglyZWFzb25pbmcYBCABKAkSEAoIc3RyYXRlZ3kYBSABKAkSEAoIcHJvZ3Jlc3MYBiABKAkSEQoJdG9vbF9uYW1lGAcgASgJEiYKBWV4dHJhGAggASgLMhcuZ29vZ2xlLnByb3RvYnVmLlN0cnVjdBIaChJlbWl0dGVkX2F0X3VuaXhfbXMYCSABKAMSFwoPcmVmbGVjdGlvbl90ZXh0GAogASgJIq0BChJQbGFubmluZ1JlZmxlY3Rpb24SMQoDcnVuGAEgASgLMiQuc2VtLm1pZGRsZXdhcmUucGxhbm5pbmcuUGxhbm5pbmdSdW4SFwoPaXRlcmF0aW9uX2luZGV4GAIgASgFEhcKD3JlZmxlY3Rpb25fdGV4dBgDIAEoCRIWCg5wcm9ncmVzc19zY29yZRgEIAEoARIaChJlbWl0dGVkX2F0X3VuaXhfbXMYBSABKAMixgEKEVBsYW5uaW5nQ29tcGxldGVkEjEKA3J1bhgBIAEoCzIkLnNlbS5taWRkbGV3YXJlLnBsYW5uaW5nLlBsYW5uaW5nUnVuEhgKEHRvdGFsX2l0ZXJhdGlvbnMYAiABKAUSFgoOZmluYWxfZGVjaXNpb24YAyABKAkSFQoNc3RhdHVzX3JlYXNvbhgEIAEoCRIXCg9maW5hbF9kaXJlY3RpdmUYBSABKAkSHAoUY29tcGxldGVkX2F0X3VuaXhfbXMYBiABKAMiaQoQRXhlY3V0aW9uU3RhcnRlZBIOCgZydW5faWQYASABKAkSFgoOZXhlY3V0b3JfbW9kZWwYAiABKAkSEQoJZGlyZWN0aXZlGAMgASgJEhoKEnN0YXJ0ZWRfYXRfdW5peF9tcxgEIAEoAyK/AQoSRXhlY3V0aW9uQ29tcGxldGVkEg4KBnJ1bl9pZBgBIAEoCRIcChRjb21wbGV0ZWRfYXRfdW5peF9tcxgCIAEoAxIOCgZzdGF0dXMYAyABKAkSFQoNZXJyb3JfbWVzc2FnZRgEIAEoCRITCgt0b2tlbnNfdXNlZBgFIAEoBRIXCg9yZXNwb25zZV9sZW5ndGgYBiABKAUSJgoFZXh0cmEYByABKAsyFy5nb29nbGUucHJvdG9idWYuU3RydWN0QlZaVGdpdGh1Yi5jb20vdGVhbS1tZW50by9tZW50by1wbGF5Z3JvdW5kL2dvL3BrZy9zZW0vcGIvcHJvdG8vc2VtL21pZGRsZXdhcmU7bWlkZGxld2FyZWIGcHJvdG8z", [file_google_protobuf_struct]);

/**
 * Shared identifier for a single planner run.
 *
 * @generated from message sem.middleware.planning.PlanningRun
 */
export type PlanningRun = Message<"sem.middleware.planning.PlanningRun"> & {
  /**
   * @generated from field: string run_id = 1;
   */
  runId: string;

  /**
   * @generated from field: string provider = 2;
   */
  provider: string;

  /**
   * @generated from field: string planner_model = 3;
   */
  plannerModel: string;

  /**
   * @generated from field: int32 max_iterations = 4;
   */
  maxIterations: number;
};

/**
 * Describes the message sem.middleware.planning.PlanningRun.
 * Use `create(PlanningRunSchema)` to create a new message.
 */
export const PlanningRunSchema: GenMessage<PlanningRun> = /*@__PURE__*/
  messageDesc(file_proto_sem_middleware_planning, 0);

/**
 * Fired once per run when planning begins.
 *
 * @generated from message sem.middleware.planning.PlanningStarted
 */
export type PlanningStarted = Message<"sem.middleware.planning.PlanningStarted"> & {
  /**
   * @generated from field: sem.middleware.planning.PlanningRun run = 1;
   */
  run?: PlanningRun;

  /**
   * @generated from field: int64 started_at_unix_ms = 2;
   */
  startedAtUnixMs: bigint;
};

/**
 * Describes the message sem.middleware.planning.PlanningStarted.
 * Use `create(PlanningStartedSchema)` to create a new message.
 */
export const PlanningStartedSchema: GenMessage<PlanningStarted> = /*@__PURE__*/
  messageDesc(file_proto_sem_middleware_planning, 1);

/**
 * Fired for each iteration the planner produces.
 *
 * @generated from message sem.middleware.planning.PlanningIteration
 */
export type PlanningIteration = Message<"sem.middleware.planning.PlanningIteration"> & {
  /**
   * @generated from field: sem.middleware.planning.PlanningRun run = 1;
   */
  run?: PlanningRun;

  /**
   * @generated from field: int32 iteration_index = 2;
   */
  iterationIndex: number;

  /**
   * @generated from field: string action = 3;
   */
  action: string;

  /**
   * @generated from field: string reasoning = 4;
   */
  reasoning: string;

  /**
   * @generated from field: string strategy = 5;
   */
  strategy: string;

  /**
   * @generated from field: string progress = 6;
   */
  progress: string;

  /**
   * @generated from field: string tool_name = 7;
   */
  toolName: string;

  /**
   * @generated from field: google.protobuf.Struct extra = 8;
   */
  extra?: JsonObject;

  /**
   * @generated from field: int64 emitted_at_unix_ms = 9;
   */
  emittedAtUnixMs: bigint;

  /**
   * @generated from field: string reflection_text = 10;
   */
  reflectionText: string;
};

/**
 * Describes the message sem.middleware.planning.PlanningIteration.
 * Use `create(PlanningIterationSchema)` to create a new message.
 */
export const PlanningIterationSchema: GenMessage<PlanningIteration> = /*@__PURE__*/
  messageDesc(file_proto_sem_middleware_planning, 2);

/**
 * Optional intermediate reflection snapshots keyed by iteration.
 *
 * @generated from message sem.middleware.planning.PlanningReflection
 */
export type PlanningReflection = Message<"sem.middleware.planning.PlanningReflection"> & {
  /**
   * @generated from field: sem.middleware.planning.PlanningRun run = 1;
   */
  run?: PlanningRun;

  /**
   * @generated from field: int32 iteration_index = 2;
   */
  iterationIndex: number;

  /**
   * @generated from field: string reflection_text = 3;
   */
  reflectionText: string;

  /**
   * @generated from field: double progress_score = 4;
   */
  progressScore: number;

  /**
   * @generated from field: int64 emitted_at_unix_ms = 5;
   */
  emittedAtUnixMs: bigint;
};

/**
 * Describes the message sem.middleware.planning.PlanningReflection.
 * Use `create(PlanningReflectionSchema)` to create a new message.
 */
export const PlanningReflectionSchema: GenMessage<PlanningReflection> = /*@__PURE__*/
  messageDesc(file_proto_sem_middleware_planning, 3);

/**
 * Fired when planning concludes (even with zero iterations).
 *
 * @generated from message sem.middleware.planning.PlanningCompleted
 */
export type PlanningCompleted = Message<"sem.middleware.planning.PlanningCompleted"> & {
  /**
   * @generated from field: sem.middleware.planning.PlanningRun run = 1;
   */
  run?: PlanningRun;

  /**
   * @generated from field: int32 total_iterations = 2;
   */
  totalIterations: number;

  /**
   * @generated from field: string final_decision = 3;
   */
  finalDecision: string;

  /**
   * @generated from field: string status_reason = 4;
   */
  statusReason: string;

  /**
   * @generated from field: string final_directive = 5;
   */
  finalDirective: string;

  /**
   * @generated from field: int64 completed_at_unix_ms = 6;
   */
  completedAtUnixMs: bigint;
};

/**
 * Describes the message sem.middleware.planning.PlanningCompleted.
 * Use `create(PlanningCompletedSchema)` to create a new message.
 */
export const PlanningCompletedSchema: GenMessage<PlanningCompleted> = /*@__PURE__*/
  messageDesc(file_proto_sem_middleware_planning, 4);

/**
 * Execution starts once a final directive is available.
 *
 * @generated from message sem.middleware.planning.ExecutionStarted
 */
export type ExecutionStarted = Message<"sem.middleware.planning.ExecutionStarted"> & {
  /**
   * @generated from field: string run_id = 1;
   */
  runId: string;

  /**
   * @generated from field: string executor_model = 2;
   */
  executorModel: string;

  /**
   * @generated from field: string directive = 3;
   */
  directive: string;

  /**
   * @generated from field: int64 started_at_unix_ms = 4;
   */
  startedAtUnixMs: bigint;
};

/**
 * Describes the message sem.middleware.planning.ExecutionStarted.
 * Use `create(ExecutionStartedSchema)` to create a new message.
 */
export const ExecutionStartedSchema: GenMessage<ExecutionStarted> = /*@__PURE__*/
  messageDesc(file_proto_sem_middleware_planning, 5);

/**
 * Completion of the execution phase; reserved for richer result payloads.
 *
 * @generated from message sem.middleware.planning.ExecutionCompleted
 */
export type ExecutionCompleted = Message<"sem.middleware.planning.ExecutionCompleted"> & {
  /**
   * @generated from field: string run_id = 1;
   */
  runId: string;

  /**
   * @generated from field: int64 completed_at_unix_ms = 2;
   */
  completedAtUnixMs: bigint;

  /**
   * @generated from field: string status = 3;
   */
  status: string;

  /**
   * @generated from field: string error_message = 4;
   */
  errorMessage: string;

  /**
   * @generated from field: int32 tokens_used = 5;
   */
  tokensUsed: number;

  /**
   * @generated from field: int32 response_length = 6;
   */
  responseLength: number;

  /**
   * @generated from field: google.protobuf.Struct extra = 7;
   */
  extra?: JsonObject;
};

/**
 * Describes the message sem.middleware.planning.ExecutionCompleted.
 * Use `create(ExecutionCompletedSchema)` to create a new message.
 */
export const ExecutionCompletedSchema: GenMessage<ExecutionCompleted> = /*@__PURE__*/
  messageDesc(file_proto_sem_middleware_planning, 6);

